// The share text, and getting it onto the clipboard (CLAUDE.md: Share is the
// primary action; The Share button reports whether the copy worked).
//
// The text opens with the site, game and number, then the result line, then one
// row of squares per guess, then the link. It ends on the link: no trailing
// blank line. The link goes to the puzzle, not the game, so a recipient opens
// what was shared rather than whatever is live when they click.
import type { GuessMarks } from './types.ts';

const SITE = 'cinemore.co.uk';
const RIGHT = '🟪';   // purple: a poster in its correct position
const WRONG = '⬜';   // white: a wrong one. No other colours.

export function shareText(number: number, won: boolean, guesses: GuessMarks[]): string {
  const lines = [
    `Cinemore · Running Order #${number}`,
    won ? `Solved in ${guesses.length}/3` : 'Missed',
    ...guesses.map((row) => row.map((right) => (right ? RIGHT : WRONG)).join('')),
    `${SITE}/running-order/${number}`
  ];
  return lines.join('\n');
}

// True only when the text really is on the clipboard. The async API is blocked
// in some browsers and contexts, so a hidden textarea stands behind it.
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the older way
  }
  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}
